<template>
  <sAlert small>
    {{ $t("Tenders.TenderCreatedAsNewStageTitle") }}
    <div>
      <router-link
        slot="desc"
        data-qa="tenderNumber"
        style="color: var(--alert-text-desc) !important"
        target="_blank"
        :to="{ name: 'tenderitem', params: { id: value.PreviousTenderId, org: $route.params.org } }">
        {{ `#${value.PreviousTenderNumber}` }}
      </router-link>
    </div>
  </sAlert>
</template>
<script>
export default {
  name: 'EventHistoryTenderCreatedAsNewStageParams',
  props: {
    value: {
      type: Object,
    },
  },
}
</script>
